export default String.raw`
<div class="cart-row">
	{% assign productNumber = include -%}
	{% assign i = productNumber | Minus:1 -%}

	{% assign productsSize = cart.Products | Size -%}
	{% assign product = cart.Products[i] -%}

	{% assign price = product.Price -%}
	{% assign productValue = product.Value -%}
	{% assign priceBefore = product.ValueBeforeDiscount -%}

	{% if config.ENTERPRISE -%}
		{% assign price = product.SubtotalPrice -%}
		{% assign productValue = product.SubtotalValue -%}
		{% assign priceBefore = product.SubtotalValueBeforeDiscount -%}
		{% assign totalPrice = product.TotalPrice -%}
		{% assign totalValue = product.TotalValue -%}
	{% endif -%}
			
	{% if product.PointsPrice != null -%}
		{% assign pointsExchange = product.PointsPrice | Ceil -%}
	{% endif -%}

	{% include 'partials/common/date-format.html' -%}

	<div class="cart-row__number">
		{{ product.No }}
	</div>

	<div class="cart-row__product cart-row__product-wrapper">
		<div class="cart-row__product-image">
			{% if product.ImageId != -1 or product.Image != null -%}
				{{ product | Img: 'small' }}
			{% else -%}
				<img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high">
			{% endif -%}
		</div>
		<div>
			{% if product.Url -%}
				<a href="{{ page.BaseHref }}{{ product.Url }}" class="cart-row__product-name">{{ product.NameNoHtml }}</a>
			{% else -%}
				<div class="cart-row__product-name">{{ product.NameNoHtml }}</div>
			{% endif -%}
			<ul class="cart-row__product-info">
				<li>{{ product.Code }}</li>
				{% if product.Description != "" -%}
					{% assign descriptionLength = product.Description | Size | Minus: 2 -%}
					{% assign description = product.Description | Slice: 0, descriptionLength | Split: ';' -%}
					{% for attribute in description -%}
						<li>
							{{ attribute }}
						</li>
					{% endfor -%}
				{% endif -%}

				{% if usr.Authenticated -%}
					{% if product.Points != null -%}
						<li class="loyalty-info">
							<svg width="24" height="24">
								<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#award-{{settings.iconStyle}}'></use>
							</svg>
							<span>
								+{{ product.Points }} {{ translations.PointsShortcut }}
							</span>
						</li>
						{% if cart.PointsPaid == null -%}
							{% if product.PointsPrice != null -%}
								<li class="loyalty-info">
									<svg width="24" height="24">
										<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#gift-card-{{settings.iconStyle}}'></use>
									</svg>
									{{ pointsExchange }} {{ translations.PointsShortcut }}
								</li>
							{% endif -%}
						{% endif -%}
					{% endif -%}
				{% endif -%}
			</ul>
			<div class="cart-row__product-info cart-hide-on-desktop">
				{% if product.Status.Text -%}
					{% unless settings.showAvailabilityStatus == 'no' and product.Status.Status == 1 -%}
						{% if product.Status.Text -%}
							<div class="cart-additional-info">
								<div class="cart-additional-info__title">{{ translations.Availability }}</div>
								<div class="cart-additional-info__content">
									{{ product.Status.Text }} {% if product.Status.Date != null -%}(<time>{{ product.Status.Date | Date:dateFormat }}</time>){% endif -%}
								</div>
							</div>
						{% endif -%}
					{% endunless -%}
				{% endif -%}
			</div>

			{% assign showCouponsPopup = false -%}
			{% if settings.couponsPresentation == "yes" and settings.showCouponsInCart == "yes" -%}
				{% assign showCouponsInCart = true -%}
			{% endif -%}
			{% if product.HasCoupons and showCouponsInCart  -%}
				{% assign showCouponsPopup = true -%}
			{% endif -%}

			{% if showCouponsPopup -%}
				<div class="coupons-on-product-presentation product-item__coupons coupons-on-product-presentation-js {% if showCouponsInCart -%} with-coupons-js {% endif -%}">
					<input type="hidden" name="productName" value="{{ product.NameNoHtml | H }}" />
					<input type="hidden" name="productCode" value="{{ product.Code | H }}" />
					 {% if product.Image.Id > 0 and product.Image.Link != null -%}
						<input type="hidden" name="productImage" value="img/small/{{ product.Image.Id }}/{{ product.Image.Link }}" />
					{% elsif product.Image.ExternalUrl != null -%}
						<input type="hidden" name="productImage" value="{{ product.Image.ExternalUrl }}" />
					{% else -%}
						<input type="hidden" name="productImage" value="" />
					{% endif -%}
					<button class="show-more-coupons-cart show-more-coupons-cart-js" data-product-id="{{product.Id}}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}">{{ translations.ShowDiscounts }}</button>
				</div>
			{% endif -%}
		</div>
	</div>
	<div class="cart-row__price">
		{% if price > 0 -%}
			<div>
				<span class="cart-bold-price">{{ price | ToPrice }}</span> 
				<span class="cart-hide-on-desktop cart-bold-price">{{ cart.CurrencyExt }}</span>
				<span class="cart-hide-on-desktop">
					{% if config.ENTERPRISE or cart.SubtotalPrices -%}
						{{translations.Netto | Downcase }}
					{% else -%}
						{{translations.Brutto | Downcase }}
					{% endif -%}
				</span>
			</div>
			{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit -%}
				<div class="cart-row__price-unit unit-ratio-info-js">
					{{ price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} / {{product.BasicUnit}}
				</div>
			{% endif -%}
		{% else -%}
			<div>{{translations.Free}}</div>
		{% endif -%}
		{% if config.ENTERPRISE -%}
			{% if totalPrice > 0 -%}
				<div class="cart-hide-on-desktop cart-small-price">
					<span>{{ totalPrice | ToPrice }}</span>
					<span class="cart-hide-on-desktop">{{ cart.CurrencyExt }}</span>
					<span class="cart-hide-on-desktop">{{translations.Brutto | Downcase}}</span>
				</div> 
				{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit -%}
					<div class="cart-small-price cart-hide-on-desktop cart-row__total-unit unit-ratio-info-js">
						{{ totalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} / {{product.BasicUnit}}
					</div>
				{% endif -%}
			{% endif -%}
		{% endif -%}
	</div>

	{% if config.ENTERPRISE -%}
		<div class="cart-row__total-price">
			{% if totalPrice > 0 -%}
				<div>{{ totalPrice | ToPrice }}</div> 
				{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit -%}
					<div class="cart-row__total-unit unit-ratio-info-js">
						{{ totalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} / {{product.BasicUnit}}
					</div>
				{% endif -%}
			{% endif -%}
		</div>
	{% endif -%}

	{% if cart.TotalDepositValue > 0 -%}
		<div class="cart-row__deposit-price">
			{% if product.DepositValue > 0 -%}
				{% assign depositValue = product.DepositValue | Times: product.Quantity -%}
				{% if product.BasicUnit != product.SaleUnit -%}
					{% assign depositValue = depositValue | Times: product.BasicUnitRatio -%}
				{% endif -%}
				{% assign depositValue = depositValue | Round: config.DecimalPlacesPrice | ToPrice -%}
				<strong class="cart-hide-on-desktop">{{ translations.Com_Deposit }}: </strong><div class="deposit">{{ depositValue }} <div class="cart-hide-on-desktop"> {{ cart.CurrencyExt }}</div></div>
				{% if product.BasicUnit != null and product.BasicUnit != product.SaleUnit %}
					<div class="deposit__unit">{{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} <div class="cart-hide-on-desktop"> {{ cart.CurrencyExt }} </div> / {{ product.BasicUnit}}</div>
				{% endif %}
			{% else -%}
				<div class="cart-hide-on-desktop">{{ translations.Com_Deposit }}: </div><div class="deposit">0,00 <div class="cart-hide-on-desktop"> {{ cart.CurrencyExt }}</div></div>
			{% endif -%}
		</div>
	{% endif -%}

	{% assign isStepper = false -%}

	{% if product.CanChangeQuantity -%}
		{% assign isStepper = true -%}
	{% endif -%}

	<div class="cart-row__quantity">
		{% if isStepper and cart.OrderStep != 'CustomerData' and cart.OrderStep != 'Summary' -%}
			<div class="form-js no-message-js change-quantity-in-cart-js cart-row__quantity-amount">
				<input type="hidden" name="__action" value="Cart/QuantityChange">
				<input type="hidden" name="no" value="{{ product.No }}">

				{% if product.SaleUnit -%}
					{% assign unitName = product.SaleUnit -%}
				{% else -%}
					{% assign unitName = product.Unit -%}
				{% endif -%}

				{% assign maxInputQuantityValue = 99999 -%}

				{% if config.Products.DecimalUnits == false -%}
					{% assign max = maxInputQuantityValue -%}
					{% assign min = 1 -%}
				{% else -%}
					{% assign max = maxInputQuantityValue -%}
					{% capture min -%}0{{ config.DecimalSeparator }}01{% endcapture -%}
				{% endif -%}

				{% if product.MinQuantity -%}
					{% assign min = product.MinQuantity | Normalize -%}
					{% assign minQ = product.MinQuantity | Normalize -%}
				{% endif -%}

				{% assign lastQuantityAttr = '' -%}

				{% if min > max and max != 0 -%}
					{% assign min = max -%}
				{% endif -%}

				{% if config.Products.DecimalUnits -%}
					{% capture inputValue -%}1{{ config.DecimalSeparator }}00{% endcapture -%}
				{% else -%}
					{% assign inputValue = 1 -%}
				{% endif -%}

				{% if inputValue > max and max != 0 -%}
					{% assign inputValue = max -%}
				{% endif -%}			

				{% if inputValue >= 0.01 -%}
					{% if config.Products.DecimalUnits or inputValue >= 1 -%}
						{% assign canChange = true -%}
					{% endif -%}
				{% endif -%}

				{% capture lastQuantityAttr -%} data-last-proper-quantity="{{ product.Quantity | Normalize }}" {% endcapture -%}

				{% assign inputValue = product.Quantity | Normalize -%}
				{% if config.Products.DecimalUnits -%}
					{% assign oldInputValue = inputValue -%}
					{% assign inputValueArray = inputValue | ToString | Split: config.DecimalSeparator -%}
					{% assign inputValueArraySize = inputValueArray | Size -%}
					{% if inputValueArraySize > 1 -%}
						{% assign decimalSize = inputValueArray[1] | Size -%}
						{% if decimalSize == 1 -%}
							{% capture inputValue -%}{{ inputValue }}0{% endcapture -%}
						{% endif -%}
					{% else -%}
						{% capture inputValue -%}{{ inputValue }}{{ config.DecimalSeparator }}00{% endcapture -%}
					{% endif -%}
				{% endif -%}

				{% if product.Multiplicity > 0 -%}
					{% assign unitMultiplicity = product.Multiplicity -%}
					{% if config.Products.DecimalUnits -%}
						{% assign inputValue = oldInputValue -%}
					{% endif -%}
					{% assign afterMinus = inputValue | Minus: product.Multiplicity -%}
					{% if afterMinus < min -%}
						{% assign min = inputValue -%}
						{% assign minQ = inputValue -%}
					{% endif -%}
				{% else -%}
					{% assign unitMultiplicity = 0 -%}
				{% endif -%}

				{% if canChange -%}
					<div class="cart-amount-stepper">
						<button 
							aria-label="{{ translations.DecreaseQuantity }}"
							class="cart-amount-stepper__minus change-quantity-js decrement-js parent-container-reload-js {% if inputValue == min or min >= max -%} disabled-js" disabled {% else -%}"{% endif -%}>
								<svg>
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#minus-{{settings.iconStyle}}"></use>
								</svg>
						</button>
						<input 
							aria-label="{{ translations.ChangeQuantity }}"
							class="parent-container-reload-js" 
							type="text" 
							name="quantity" 
							value="{{inputValue}}" 
							data-min="{{min}}" 
							data-max="{{ max }}" 
							{% if minQ -%} data-minq="{{minQ}}" {% endif -%} 
							{% if unitMultiplicity > 0 -%} data-multiplicity="{{unitMultiplicity}}" {% endif -%} 
							data-name="{{product.NameNoHtml | H}}" 
							data-no="{{product.No}}" 
							data-price-number="{% if totalPrice -%}{{totalPrice}}{% elseif price -%}{{price}}{% else -%}{{product.Price}}{% endif -%}" 
							data-price="{{ product.Price | ToPrice }}" {{lastQuantityAttr}}
						>
						<button 
							aria-label="{{ translations.IncreaseQuantity }}"
							class="cart-amount-stepper__plus change-quantity-js increment-js parent-container-reload-js {% if inputValue == max or min >= max -%} disabled-js" disabled {% else -%}"{% endif -%}>
								<svg>
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#plus-{{settings.iconStyle}}"></use>
								</svg>
						</button>
					</div>
					<div class="cart-amount-stepper-unit">
						{{ unitName }}
					</div>
					<div class="cart-amount-stepper-validation {% if unitMultiplicity > 0 -%} higher {% endif -%} cart-amount-stepper-validation-js">
						<div class="cart-amount-stepper-validation__error validation-info-js validation-required-js hidden-js">{{ translations.FillQuantity }}</div>
						<div class="cart-amount-stepper-validation__error validation-info-js validation-quantity-range-js hidden-js">
							{{ translations.FillProperQuantityRange }} 
							<span>{{ min }}</span> - <span class="max-js">{{ max }}</span>
						</div>
						<div class="cart-amount-stepper-validation__error validation-info-js validation-quantity-range-max-js hidden-js">
							{{ translations.FillProperQuantityRangeMax }} <span class="max-js">{{ max }}</span>
						</div>
						{% if product.MinQuantity -%}
							<div class="cart-amount-stepper-validation__error validation-info-js validation-min-quantity-js hidden-js">
								{{ translations.FillProperMinQuantity }} <span>{{ min }}</span> <span>{{ unitName }}</span>
							</div>
						{% endif -%}
						{% if unitMultiplicity > 0 -%}
							<div class="multiplicity-info-js">
								{{ translations.Multiplicity }} <span class="multiplicity-js">{{ unitMultiplicity }}</span> <span class="name-js">{{ unitName }}</span>
							</div>
						{% endif -%}
					</div>
				{% endif -%}
			</div>
		{% else -%}
			<div class="cart-row__quantity-amount">
				<div>
					{% if config.Products.DecimalUnits -%}
						{{product.Quantity}}
					{% else -%}
						{{product.Quantity | Normalize }}
					{% endif -%}
				</div>
				<div class="cart-amount-stepper-unit">
					{{product.SaleUnit}}
				</div>
			</div>
		{% endif-%}
		{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit %}
			<div class="cart-row__quantity-info unit-ratio-info-js">
				1 {{product.SaleUnit}} = {{product.BasicUnitRatio | Round: 4}} {{product.BasicUnit}}
			</div>
		{% endif -%}
	</div>

	<div class="cart-row__additional cart-hide-on-desktop">
		<div class="cart-additional-info">
			<div class="cart-additional-info__title">{{ translations.Vat }}:</div>
			<div class="cart-additional-info__content">{{ product.VAT}} %</div>
		</div>
		{% if isDiscount -%}
			<div class="cart-additional-info">
				<div class="cart-additional-info__title">{{translations.Discount}}:</div>
				<div class="cart-additional-info__content">
					{% if product.NoDiscount -%}
						{{ translations.NoDiscountProduct }}
					{% else -%}
						{% if priceBefore != 0 and productValue != 0 -%}
							{% if product.Discount != 0-%}
								{{product.Discount}} %
							{% endif -%}
						{% endif -%}
						{% if productValue == 0 -%}
							100 %
						{% endif -%}
					{% endif -%}
				</div>
			</div>
		{% endif -%}
	</div>

	<div class="cart-row__value">
		{% if config.ENTERPRISE -%}
			{% if cart.SubtotalPrices -%}
				{% if productValue > 0 -%}
				{% assign nettoPriceShown = true -%}
					<div>
						<span class="cart-bold-price">{{ productValue | ToPrice }}</span>
						<span class="cart-hide-on-desktop cart-bold-price">{{ cart.CurrencyExt }}</span>
						<span class="cart-hide-on-desktop">{{translations.Netto | Downcase}}</span>
					</div>
				{% endif -%}
				{% if totalValue > 0 -%}
					<div class="cart-small-price cart-hide-on-desktop">
						<span>{{ totalValue | ToPrice }}</span>
						<span>{{ cart.CurrencyExt }}</span>
						<span>{{translations.Brutto | Downcase}}</span>
					</div>
				{% endif -%}
			{% else -%}
				{% if totalValue > 0 -%}
					<div>
						<span class="cart-bold-price">{{ totalValue | ToPrice }}</span>
						<span class="cart-hide-on-desktop cart-bold-price">{{ cart.CurrencyExt }}</span>
						<span class="cart-hide-on-desktop">{{translations.Brutto | Downcase}}</span>
					</div>
				{% endif -%}
				{% if productValue > 0 -%}
					<div class="cart-small-price cart-hide-on-desktop">
						<span>{{ productValue | ToPrice }}</span>
						<span>{{ cart.CurrencyExt }}</span>
						<span>{{translations.Netto | Downcase}}</span>
					</div>
				{% endif -%}
			{% endif -%}
		{% else -%}
			{% if productValue > 0 -%}
				<div>
					<span class="cart-bold-price">{{ productValue | ToPrice}}</span>
					<span class="cart-hide-on-desktop cart-bold-price">{{ cart.CurrencyExt }}</span>
					<span class="cart-hide-on-desktop">{{translations.Brutto | Downcase}}</span>
				</div>
			{% endif -%}
		{% endif -%}
	</div>

	<div class="cart-row__currency">
		{{ cart.CurrencyExt }}
	</div>

	<div class="cart-row__options">
		{% unless product.IsSetElement or product.Description == "" and product.Weight <= 0 and product.Status.Text == null -%}
			<button class="cart-row__options-btn chevron expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
				<svg>
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		{% endunless -%}
		{% if product.CanDelete and cart.OrderStep != 'CustomerData' and cart.OrderStep != 'Summary' -%}
			<div class="cart-row__options-deleter form-js no-message-js">
				<input type="hidden" name="__action" value="Cart/PositionDelete">
				<input type="hidden" name="no" value="{{ product.No }}">
				{% if product.IsSetElement -%}
					<input type="hidden" name="position" value="true">
				{% endif -%}
				<button class="cart-row__options-btn remove-product-from-cart-js parent-container-reload-js {% if productsSize == 1 -%} last-product-js {% endif -%}" title="{{ translations.Delete }}" data-id="{{product.Id}}" data-name="{{ product.NameNoHtml | H }}" data-price="{{ product.TotalPrice }}">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
					</svg>
				</button>
			</div>
		{% endif -%}
	</div>
</div>

<div class="cart-row__expandable {% unless product.IsSetElement -%} expandable-js {% endunless -%}">
	<div class="cart-row__additional-info">
		{% if product.Status.Text -%}
			{% unless settings.showAvailabilityStatus == 'no' and product.Status.Status == 1 -%}
				{% if product.Status.Text -%}
					<div class="cart-additional-info">
						<div class="cart-additional-info__title">{{ translations.Availability }}</div>
						<div class="cart-additional-info__content">
							{{ product.Status.Text }} {% if product.Status.Date != null -%}(<time>{{ product.Status.Date | Date:dateFormat }}</time>){% endif -%}
						</div>
					</div>
				{% endif -%}
			{% endunless -%}
		{% endif -%}

		<div class="cart-additional-info">
			<div class="cart-additional-info__title">{{ translations.Vat }}</div>
			<div class="cart-additional-info__content">{{ product.VAT}} %</div>
		</div>

		{% if config.ENTERPRISE or cart.SubtotalPrices -%}
			{% if nettoPriceShown -%}
				{% if totalValue > 0 -%}
					<div class="cart-additional-info">
						<div class="cart-additional-info__title">{{translations.Value}} {{translations.Brutto | Downcase}}</div>
						<div class="cart-additional-info__content">{{ totalValue | ToPrice }} {{ cart.CurrencyExt }}</div>
					</div>
				{% endif -%}
			{% else -%}
				{% if productValue > 0 -%}
					<div class="cart-additional-info">
						<div class="cart-additional-info__title">{{translations.Value}} {{translations.Netto | Downcase}}</div>
						<div class="cart-additional-info__content">{{ productValue | ToPrice }} {{ cart.CurrencyExt }}</div>
					</div>
				{% endif -%}
			{% endif -%}
		{% endif -%}

		{% if product.DepositValue > 0 -%}
			<div class="cart-additional-info">
				<div class="cart-additional-info__title">{{translations.Com_Deposit}}</div>
				<div class="cart-additional-info__content">{{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ cart.CurrencyExt }} / {% if product.BasicUnit == null -%} {{ product.SaleUnit }} {% else -%} {{ product.BasicUnit }} {% endif -%}</div>
			</div>
		{% endif -%}

		{% if isDiscount -%}
			<div class="cart-additional-info">
				<div class="cart-additional-info__title">{{translations.Discount}}</div>
				<div class="cart-additional-info__content">
					{% if product.NoDiscount -%}
						{{ translations.NoDiscountProduct }}
					{% else -%}
						{% if priceBefore != 0 and productValue != 0 -%}
							{% if product.Discount != 0-%}
								{{product.Discount}} %
							{% endif -%}
						{% endif -%}
						{% if productValue == 0 -%}
							100 %
						{% endif -%}
					{% endif -%}
				</div>
			</div>
		{% endif -%}

		{% if usr.Authenticated -%}
			{% if product.Points != null -%}
				<div class="cart-additional-info">
					<span class="cart-additional-info__title">{{ translations.YouWillGet }}</span>
					<span class="cart-additional-info__content">
						+{{ product.Points }} {{ translations.PointsShortcut }}
					</span>
				</div>
				
				{% if cart.PointsPaid == null -%}
					{% if product.PointsPrice != null -%}
						<div class="cart-additional-info">
							<div class="cart-additional-info__title">{{translations.ChangeFor}}</div>
							<div class="cart-additional-info__content">
								{{ pointsExchange }} {{ translations.PointsShortcut }}
							</div>
						</div>
					{% endif -%}
				{% endif -%}
			{% endif -%}
		{% endif -%}
	</div>
</div>
`